import type { GridRenderCellParams } from "@mui/x-data-grid";
import { IconLinkButton } from "@components";

export const TableActionsCell = (props: GridRenderCellParams<any, any>) => {
  const hasAccess = true;
  const to = `/languages/${props?.row.id}/edit`;

  if (hasAccess) {
    return <IconLinkButton to={to} />;
  }

  return null;
};
